module.exports = __webpack_public_path__ + "img/OVAL.aa799ec9.png";